var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contain"},[_vm._l((_vm.paragraphs),function(p){return _c('p',{key:p},[_vm._v(_vm._s(p))])}),_c('CardActions',[_c('Button',{on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.$t('arrow_match_button_continue')))])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }